import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { ActionCreators } from "../../actions";

class OCLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        email: "",
        password: ""
      },
      errors: []
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  login() {
    this.props.userLogin(this.state.user).then(res => {
      console.log(this.props.isLoggedin);
      if (this.props.isLoggedin) this.props.push("/aoc/home");
    });
  }

  register() {
    this.props.push("/oc/register");
  }

  handleSubmit(event) {
    event.preventDefault();
    this.login();
  }

  render() {
    return (
      <div className="card">
        <div className="card-body">
          <div className="card-title text-center">
            <img
              src="/images/devstack_logo.png"
              className="img-fluid"
              alt="DevStack"
            />
          </div>
          <h5 className="card-subtitle text-center mb-5 text-muted">
            DevStack Recruitment Backoffice
          </h5>
          <form onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="col">
                <div className="form-field">
                  <label>Email</label>
                  <input
                    autoFocus={true}
                    type="email"
                    value={this.state.user.email}
                    onChange={event => {
                      this.setState({
                        ...this.state,
                        user: {
                          ...this.state.user,
                          email: event.target.value
                        }
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="form-field">
                  <label>Password</label>
                  <input
                    type="password"
                    value={this.state.user.password}
                    onChange={event => {
                      this.setState({
                        ...this.state,
                        user: {
                          ...this.state.user,
                          password: event.target.value
                        }
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <input
                  type="submit"
                  value="Login"
                  className="gs-btn gs-btn-blue mt-5"
                />
              </div>
            </div>
            {/* <div className="row">
              <div className="col">
                <button
                  onClick={() => {
                    this.register();
                  }}
                  className="gs-btn gs-btn-grey mt-3"
                >
                  Register
                </button>
              </div>
            </div> */}
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedin: state.isLoggedin
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OCLogin)
);



// WEBPACK FOOTER //
// ./src/pages/unauth/ocLogin.js